import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

const questions = [
  {
    question: "How do I choose an enrichment product for my pet?",
    answer:
      "Start with an easy, open design if your pet is new to enrichment. Move to medium or tricky designs only after your pet is comfortable and successful with the simpler option.",
  },
  {
    question: "Are Pawluna feeders and lick mats food safe?",
    answer:
      "Each product page lists its material. Our molded feeding products are described as food-grade and BPA-free where applicable. Stop use if a product becomes cracked, torn, or damaged.",
  },
  {
    question: "How should I clean the products?",
    answer:
      "Follow the care information on the product page. Many molded items are top-rack dishwasher safe, while fabric snuffle mats should be washed according to their material instructions.",
  },
  {
    question: "Should pets be supervised?",
    answer:
      "Yes. Enrichment feeders and mats are not indestructible chew toys. Supervise use, choose an appropriate size, and remove the item if your pet begins tearing or swallowing any part of it.",
  },
  {
    question: "How long will delivery take?",
    answer:
      "Available delivery estimates are shown on our Delivery page and at checkout. Timing can vary by destination, carrier conditions, holidays, and customs processing.",
  },
  {
    question: "Can I return an item?",
    answer:
      "Eligible unused items in their original condition and packaging may be returned within 30 days. Please review our Returns Policy before sending anything back.",
  },
  {
    question: "How can I contact Pawluna?",
    answer:
      "Email many@pawluna.art or write to Pawluna, 60 Harris Rd, Mineral Bluff, GA 30559 US. Please include your order number when asking about an order.",
  },
];

function FAQs() {
  return (
    <div className="privacy">
      <Header />
      <div className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12 center-column content-with-background" id="content">
                      <div style={{ paddingBottom: 10 }}>
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            <h1 className="pdh-policy-title">Frequently Asked Questions</h1>
                            <div className="pdh-policy-layout">
                              <div className="pdh-policy-main">
                                <div className="pdh-policy-intro-box">
                                  <p>
                                    Helpful answers about Pawluna products, care,
                                    delivery, returns, and support.
                                  </p>
                                </div>
                                <div className="pdh-policy-sections">
                                  {questions.map((item, index) => (
                                    <div className="pdh-policy-section" key={item.question}>
                                      <ol start={index + 1}>
                                        <li className="pdh-policy-section-title">
                                          {item.question}
                                        </li>
                                      </ol>
                                      <div className="pdh-policy-section-content">
                                        <p className="pdh-policy-text">{item.answer}</p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQs;
